import React, { useEffect, useMemo, useState } from "react";
import SearchBar from "../../components/universal/SearchBar";
import SquareCard from "../../components/universal/SquareCard";
import squareIcon1 from "../../assets/icons/squareCard/icon1.svg";
import ChurchIcon from "../../assets/icons/church.png";
import CustomCarousel from "../../components/universal/CustomCarousel";
import SingleTab from "../../components/universal/SingleTab";
import { AiOutlinePlus, AiOutlineReload } from "react-icons/ai";
import { Link, useNavigate,useLocation } from "react-router-dom";
import ChurchHooks from "./hooks/Churchhooks";
import Navbar from "../../components/universal/Navbar";
import { useDispatch } from "react-redux";
import { videosDashboardAction } from "../../store/Layout/LayoutAction";
import {
  readEntityContentAnalyticsRequest,
  readEntityContentViewsAnalyticsRequest,
  readEntityContentViewsTrendingRequest,
} from "../../store/EntityAnalytics/entityAnalyticsActions";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import ReactECharts from "echarts-for-react";
import CustomBarChart from "../../components/charts/barChart/CustomBarChart";
import DateFilter from "../../components/universal/DateFilter";
import { subDays } from "date-fns";
import { FaDownload } from "react-icons/fa6";
import { downloadExcel } from "../../utils/DownloadExcel";
import { AiOutlineDown } from "react-icons/ai";
import { IoCloseOutline } from "react-icons/io5";
import ChurchModal from "./ChurchModal";
import { useSelector } from "react-redux";
import { fetchChurchesRequest } from "../../store/Churches/actions";

const EMPTY_ARRAY = [];

const areTrendingItemsSame = (prev = [], next = []) => {
  if (prev.length !== next.length) return false;
  return prev.every((item, index) =>
    item?._id === next[index]?._id &&
    item?.entityObjId === next[index]?.entityObjId &&
    Number(item?.likeCount || 0) === Number(next[index]?.likeCount || 0)
  );
};

function Churches() {
  // search bar component state with handler
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);
  const { value, onChangeSearchBar } = ChurchHooks();
  // tab clicking state for language table
  const [activeTab, setActiveTab] = useState("Trending");
  const [loading, setLoading] = useState(true);
  const [userTab] = useState("Content");
  const [trendingVideos, setTrendingVideos] = useState([]);
  const [churchOptions, setChurchOptions] = useState(() => {
    try {
      const savedOptions = JSON.parse(localStorage.getItem("churchOptions") || "[]");
      return Array.isArray(savedOptions) ? savedOptions : [];
    } catch {
      return [];
    }
  });
  const [selectedChurchId, setSelectedChurchId] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("church") || "null")?._id || "";
    } catch {
      return "";
    }
  });
  const [selectedChurchName, setSelectedChurchName] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("church") || "null")?.churchName || "";
    } catch {
      return "";
    }
  });


  const [chartData, setChartData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [animate, setAnimate] = useState(false);

  const navigate = useNavigate();


  const onNavigateToAddVideos = () => {
    navigate("/churches/add", { state: { _id: "" } });
  };
  const [isOpen, setIsOpen] = useState(false);
  const [selectedChurch, setSelectedChurch] = useState("Select Church");

  const churches = ["Church 1", "Church 2", "Church 3", "Church 4"];

  const handleSelect = (church) => {
    setSelectedChurch(church);
    setIsOpen(false);
  };
  const [filterRange, setFilterRange] = useState([
    {
      startDate: subDays(new Date(), 7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const fetchReportsData = ({ startDate, endDate }) => {
    setLoading(true);
    let completed = false;

    const finishLoading = () => {
      if (completed) return;
      completed = true;
      setLoading(false);
    };

    const loadingFallback = window.setTimeout(finishLoading, 12000);

    dispatch(
      videosDashboardAction({
        apiPayloadRequest: {
          startDate: startDate ?? null,
          endDate: endDate ?? null,
        },
        callback: (res) => {
          window.clearTimeout(loadingFallback);
          const data = res?.data ? res?.data : [];
          if (res?.type === 1) {
            setCountryData(
              data?.filter((item) => item.dash === "Country based video Likes")[0]?.data || []
            );

            setLanguageData(
              data?.filter((item) => item.dash === "Language based video likes")[0]?.data || []
            );

            // Entity analytics handles trending/most liked/most watched data.
          }
          finishLoading();
        },
      })
    );
  };

  useEffect(() => {
    fetchReportsData({
      startDate: filterRange?.[0]?.startDate,
      endDate: filterRange?.[0]?.endDate,
    });
  }, [filterRange]);

  const { viewsTrending } = useSelector(
    (state) => state.entityAnalytics || {}
  );
  const [selectedChurchContentSummary, setSelectedChurchContentSummary] = useState(null);
  const contentSummary = selectedChurchContentSummary || {};
  const trendingEntities = viewsTrending?.data?.trendingEntities || EMPTY_ARRAY;
  const trendingBuckets = viewsTrending?.data?.trendingBuckets || EMPTY_ARRAY;
  const mostViewedEntity = useMemo(() => {
    const entityViewsBucket = Array.isArray(trendingBuckets)
      ? trendingBuckets.find((b) => b?.bucket === "entityViews")
      : null;
    if (entityViewsBucket?.details?.length) {
      return entityViewsBucket.details.reduce((best, current) => {
        const bestViews = Number(best?.views ?? 0);
        const currentViews = Number(current?.views ?? 0);
        return currentViews > bestViews ? current : best;
      }, entityViewsBucket.details[0]);
    }
    if (!Array.isArray(trendingEntities) || trendingEntities.length === 0) return null;
    return trendingEntities.reduce((best, current) => {
      const bestViews = Number(best?.totalViews ?? best?.views?.totalViews ?? 0);
      const currentViews = Number(current?.totalViews ?? current?.views?.totalViews ?? 0);
      return currentViews > bestViews ? current : best;
    }, trendingEntities[0]);
  }, [trendingBuckets, trendingEntities]);

  const contentBreakdown = [
    { label: "Videos", value: Number(contentSummary?.videos || 0) },
    { label: "Curriculums", value: Number(contentSummary?.curriculums || 0) },
    { label: "Plans", value: Number(contentSummary?.plans || 0) },
    { label: "Campuses", value: Number(contentSummary?.campuses || 0) },
    { label: "Carecells", value: Number(contentSummary?.carecells || 0) },
    { label: "Journals", value: Number(contentSummary?.journals || 0) },
    { label: "Members", value: Number(contentSummary?.members || 0) },
    { label: "Programs", value: Number(contentSummary?.programs || 0) },
    { label: "Services", value: Number(contentSummary?.services || 0) },
    { label: "Bulletins", value: Number(contentSummary?.bulletins || 0) },
  ];
  const selectedChurchRows = [
    { label: "Videos", value: Number(selectedChurchContentSummary?.videos || 0) },
    { label: "Curriculums", value: Number(selectedChurchContentSummary?.curriculums || 0) },
    { label: "Plans", value: Number(selectedChurchContentSummary?.plans || 0) },
    { label: "Campuses", value: Number(selectedChurchContentSummary?.campuses || 0) },
    { label: "Carecells", value: Number(selectedChurchContentSummary?.carecells || 0) },
    { label: "Journals", value: Number(selectedChurchContentSummary?.journals || 0) },
    { label: "Members", value: Number(selectedChurchContentSummary?.members || 0) },
    { label: "Programs", value: Number(selectedChurchContentSummary?.programs || 0) },
    { label: "Services", value: Number(selectedChurchContentSummary?.services || 0) },
    { label: "Bulletins", value: Number(selectedChurchContentSummary?.bulletins || 0) },
  ];
  const pieChartData = selectedChurchRows.map((item) => ({
    name: item.label,
    value: item.value,
  }));
  const barChartLabels = selectedChurchRows.map((item) => item.label);
  const barChartValues = selectedChurchRows.map((item) => item.value);
  const totalChurchesCount = churchOptions.length;
  const mostViewedChurchMatch = churchOptions.find(
    (ch) => ch?._id === mostViewedEntity?.entityObjId
  );
  const mostViewedChurchName =
    mostViewedChurchMatch?.churchName || mostViewedEntity?.entityName || "N/A";
  const mostViewedChurchLogo = ChurchIcon;
  const mostViewedChurchViews = Number(
    mostViewedEntity?.views ??
      mostViewedEntity?.totalViews ??
      mostViewedEntity?.views?.totalViews ??
      0
  );

  const mapTrendingEntities = (entities = []) =>
    entities.map((item) => ({
      ...item,
      title: item?.entityName,
      likeCount: item?.totalViews || item?.views?.totalViews || 0,
    }));

  useEffect(() => {
    const mapped = mapTrendingEntities(trendingEntities);
    setTrendingVideos((prev) => (areTrendingItemsSame(prev, mapped) ? prev : mapped));
  }, [trendingEntities]);

  useEffect(() => {
    const nextChartData = {
      xAxis: selectedChurchRows.map((item) => item.label),
      yAxis: pieChartData,
    };

    setChartData((prev) =>
      JSON.stringify(prev) === JSON.stringify(nextChartData) ? prev : nextChartData
    );
  }, [selectedChurchContentSummary]);


  useEffect(() => {
    dispatch(readEntityContentAnalyticsRequest({ typeofentity: "1" }, () => {}));
    dispatch(readEntityContentViewsAnalyticsRequest({ typeofentity: "1" }, () => {}));
    dispatch(
      readEntityContentViewsTrendingRequest({ typeofentity: "1", top: 10 }, () => {})
    );
  }, [dispatch]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== "church") return;
      try {
        const nextChurch = JSON.parse(e.newValue || "null");
        setSelectedChurchId(nextChurch?._id || "");
        setSelectedChurchName(nextChurch?.churchName || "");
      } catch {
        setSelectedChurchId("");
        setSelectedChurchName("");
      }
    };

    const onChurchChange = (e) => {
      setSelectedChurchId(e?.detail?._id || "");
      setSelectedChurchName(e?.detail?.churchName || "");
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener("church:change", onChurchChange);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("church:change", onChurchChange);
    };
  }, []);

  useEffect(() => {
    dispatch(
      fetchChurchesRequest({ apiPayloadRequest: { typeofentity: "1" } }, (res) => {
        if (res?.type !== 1 || !Array.isArray(res?.data)) return;
        setChurchOptions(res.data);
        localStorage.setItem("churchOptions", JSON.stringify(res.data));
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!Array.isArray(churchOptions) || churchOptions.length === 0) return;

    const selectedChurchExists = churchOptions.some((church) => church?._id === selectedChurchId);
    if (selectedChurchId && selectedChurchExists) {
      const selectedChurch = churchOptions.find((church) => church?._id === selectedChurchId);
      if (selectedChurch?.churchName && selectedChurchName !== selectedChurch.churchName) {
        setSelectedChurchName(selectedChurch.churchName);
      }
      return;
    }

    const firstChurch = churchOptions[0];
    setSelectedChurchId(firstChurch?._id || "");
    setSelectedChurchName(firstChurch?.churchName || "");
    if (firstChurch?._id) {
      localStorage.setItem("church", JSON.stringify(firstChurch));
      localStorage.setItem("churchOptions", JSON.stringify(churchOptions));
      window.dispatchEvent(new CustomEvent("church:change", { detail: firstChurch }));
    }
  }, [churchOptions, selectedChurchId, selectedChurchName]);

  useEffect(() => {
    if (!selectedChurchId) return;
    dispatch(
      fetchChurchesRequest(
        {
          apiPayloadRequest: {
            page: 1,
            limit: 0,
            searchCriteria: {},
            typeofentity: "1",
            _id: selectedChurchId,
          },
        },
        (res) => {
          if (res?.type !== 1 || !Array.isArray(res?.data) || res.data.length === 0) {
            setSelectedChurchContentSummary(null);
            setChartData({ xAxis: [], yAxis: [] });
            return;
          }

          const selectedChurchData = res.data[0] || {};
          setSelectedChurchContentSummary({
            videos: Number(selectedChurchData?.videos?.length || 0),
            curriculums: Number(selectedChurchData?.curriculums?.length || 0),
            plans: Number(selectedChurchData?.plans?.length || 0),
            campuses: Number(selectedChurchData?.campuses?.length || 0),
            carecells: Number(selectedChurchData?.carecells?.length || 0),
            journals: Number(selectedChurchData?.journals?.length || 0),
            members: Number(selectedChurchData?.teammembers?.length || 0),
            programs: Number(selectedChurchData?.programs?.length || 0),
            services: Number(selectedChurchData?.services?.length || 0),
            bulletins: Number(
              selectedChurchData?.weeklybulletins?.length ||
                selectedChurchData?.bulletins?.length ||
                0
            ),
          });
          setSelectedChurchName(selectedChurchData?.churchName || "");
        }
      )
    );
  }, [dispatch, selectedChurchId]);

  const [isModalOpen, setIsModalOpen] = useState(false); // ✅ modal state
 const location = useLocation();
  const hideUI = location.pathname.includes("addfield") ||location.pathname.includes("addChannelField");
  return (
    <>
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
    {!hideUI && <Navbar />}

      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
      <div className="flex flex-col gap-4 h-full">

      {!hideUI && (
        <SearchBar
          placeholder={"Search"}
          value={value}
          onChangeSearchBar={onChangeSearchBar}
          showChurchDropdown={true}
          churchOptions={churchOptions}
          selectedChurchId={selectedChurchId}
          onChangeChurch={(churchId) => {
            setSelectedChurchId(churchId);
            const selected = churchOptions.find((church) => church?._id === churchId);
            setSelectedChurchName(selected?.churchName || "");
            if (selected) {
              localStorage.setItem("church", JSON.stringify(selected));
              localStorage.setItem("churchOptions", JSON.stringify(churchOptions));
              window.dispatchEvent(new CustomEvent("church:change", { detail: selected }));
            }
          }}
        />
      )}

        <div className="flex flex-col gap-4 h-full">
          <div
            className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4 relative"
            id="reportContainer"
          >
            {
                !hideUI&&
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
             <div className="flex justify-between items-center flex-1">
                <p className=" text-white text-3xl font-medium flex items-center gap-3">
                  Churches
                  <AiOutlineReload
                    className={`cursor-pointer text-2xl text-yellowish ${
                      loading ? "animate-spin" : ""
                    }`}
                    onClick={() =>
                      fetchReportsData({
                        startDate: filterRange?.[0]?.startDate,
                        endDate: filterRange?.[0]?.endDate,
                      })
                    }
                  />
                </p>
                <div className="flex gap-3 items-center">
                  <DateFilter range={filterRange} setRange={setFilterRange} />
                </div>
              </div>
              <div className="flex gap-4 justify-end">
                <Link to={"/churches/all"}
                 onClick={() => {
                  const church = localStorage.getItem("ministry");
                  if (church) {
                    localStorage.removeItem("ministry");
                  }
                }}>

                               <button className=" text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                                 See All churches
                               </button>
                             </Link>
                <button
                  // onClick= {()=>setIsModalOpen(true)}
                  onClick={() => {
                    localStorage.removeItem("church");
                    window.dispatchEvent(new CustomEvent("church:change", { detail: null }));
                    navigate("/addfield", { state: { church: null, mode: "create" } });
                  }}
                  className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                >
                  <AiOutlinePlus /> Add Church
                </button>

                </div>
                </div>
            }

            <div className={`${!hideUI?'flex gap-4 flex-wrap':'grid grid-cols-2 gap-4'}`}>

              <SquareCard
                heading={"No. of Total Churches"}
                icon={ChurchIcon}
                iconStyle={"h-11 w-11"}
                info={totalChurchesCount}
                downloadIcon={true}
                downloadIconClickHandle={() => {
                  downloadExcel([
                    ...(trendingVideos?.map((d) => ({
                      "Entity Name": d?.title,
                      "Total Views": d?.likeCount,
                    })) ?? []),
                  ]);
                }}
                trail={""}
                percentage={""}
                handleOnClick={() => {
                  setAnimate((prev) => !prev);
                  setActiveTab("Trending");
                }}
              />
              <div
                className="cursor-pointer relative md:w-56 md:h-44 rounded-2xl border border-greyishV2 border-opacity-50 flex flex-col justify-between bg-blackishV2 p-4"
                onClick={() => {
                  if (!mostViewedEntity?.entityObjId) return;
                  const churchPayload = mostViewedChurchMatch || {
                    _id: mostViewedEntity?.entityObjId,
                    churchName: mostViewedChurchName,
                  };
                  navigate("/addfield", { state: { church: churchPayload } });
                }}
              >
                <p className="text-sm text-greyish">Most Viewed Church</p>
                <div className="flex items-center gap-3">
                  <img className="h-11 w-11 object-contain" src={mostViewedChurchLogo} alt="" />
                  <p className="text-white text-sm font-semibold truncate">
                    {mostViewedChurchName}
                  </p>
                </div>
                <div className="flex flex-col gap-1">
                  <p className="text-greyish text-xs">Total Views</p>
                  <p className="text-yellowish text-xl font-bold">
                    {mostViewedChurchViews}
                  </p>
                </div>
              </div>

            </div>
            <div className={`${!hideUI ?'grid grid-rows-1 md:grid-cols-6 grid-cols-1 flex-1 h-full gap-x-4 gap-y-4 my-4':'space-y-4'}`}>

              <div className="md:col-span-3 row-span-1 bg-blackishV2 px-6 py-4 rounded-2xl flex justify-between">
                <div className="text-white w-full">
                  <div className="flex justify-between items-center w-full">
                    <div className="flex items-center gap-8">
                      <div className="flex flex-col">
                        <p className="text-lg font-semibold text-white">Content Breakdown</p>
                      </div>
                    </div>
                    <div className="md:w-[15vw] w-full">
                      <div className="">
                        <CustomCarousel
                          rows={1}
                          cols={2}
                          gapX={0}
                          gapY={0}
                          // easier to pass this array like this rather than separating it
                          completeSliders={[
                            <SingleTab
                              activeTab={userTab}
                              tab={"Content"}
                              tabClassName="whitespace-nowrap"
                            />,
                          ]}
                          numberOfCardsShownInSingleSlide={3}
                          handleCardOnClick={(card) => {
                            setChartData({
                              xAxis: contentBreakdown.map((item) => item.label),
                              yAxis: contentBreakdown.map((item) => ({
                                name: item.label,
                                value: item.value,
                              })),
                            });
                          }}
                          topNext={"hidden"}
                          topPrev={"hidden"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="block relative">
                    {chartData?.xAxis?.length > 0 && (
                      <>
                        <button
                          className="text-yellowish absolute top-2 right-2 z-50"
                          onClick={() => {
                            downloadExcel([
                              ...(chartData?.yAxis?.map((d) => ({
                                "Content Type": d?.name,
                                "Total Count": d?.value,
                              })) ?? []),
                            ]);
                          }}
                        >
                          <FaDownload />
                        </button>
                        <ReactECharts
                          className="py-4 bg-blackish mt-5"
                          option={{
                            tooltip: {
                              trigger: "item",
                              axisPointer: {
                                type: "shadow",
                              },
                            },
                            series: [
                              {
                                data: [...chartData?.yAxis],
                                color: ["#EFBC51"],
                                label: {
                                  color: "#fff",
                                },
                                name: userTab,
                                type: "pie",
                                radius: ["40%", "70%"],
                                avoidLabelOverlap: true,
                                padAngle: 5,
                                itemStyle: {
                                  borderRadius: 10,
                                },
                              },
                            ],
                          }}
                          notMerge={true}
                          lazyUpdate={true}
                          theme={"halloween"}
                          onChartReady={() => undefined}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
                <div className="md:col-span-3 row-span-1 bg-blackishV2 px-6 py-4 rounded-2xl flex flex-col gap-4">
                <div className="flex justify-between md:items-center md:flex-row flex-col gap-4">
                  <div className="flex flex-col">
                    <p className="text-lg font-semibold text-white">Church Content Breakdown</p>
                    {selectedChurchName && (
                      <p className="text-xs text-greyish mt-1">{selectedChurchName}</p>
                    )}
                  </div>
                  <div className="md:w-[20vw] w-full">
                    <select
                      className="bg-blackish p-2 text-white text-[13px] rounded-md h-10 border border-greyishV2 border-opacity-50 w-full"
                      value={selectedChurchId}
                      onChange={(e) => {
                        const nextId = e.target.value;
                        setSelectedChurchId(nextId);
                        const match = churchOptions.find((c) => c?._id === nextId);
                        setSelectedChurchName(match?.churchName || "");
                      }}
                    >
                      {churchOptions.length === 0 && (
                        <option value="">No churches</option>
                      )}
                      {churchOptions.map((ch) => (
                        <option key={ch?._id} value={ch?._id}>
                          {ch?.churchName || "Unnamed Church"}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className={`${
                    animate
                      ? "absolute bg-blackishV2 w-full h-full left-0  top-0 p-5 rounded-lg z-50 transition-all duration-500 ease-out overflow-y-auto"
                      : "transition-all duration-500 ease-in-out"
                  }`}
                >
                  {animate && (
                    <button
                      className="flex gap-2 font-bold text-xs px-4 py-2 bg-yellowish rounded-md"
                      onClick={() => setAnimate((prev) => !prev)}
                    >
                      <FaRegArrowAltCircleLeft size={16} /> <p>Back</p>
                    </button>
                  )}
                  <div className="w-full h-full relative">
                    <button
                      className="text-yellowish absolute top-2 right-2 z-50"
                      onClick={() => {
                        downloadExcel(
                          selectedChurchRows.map((d) => ({
                            "Content Type": d.label,
                            "Total Count": d.value,
                          }))
                        );
                      }}
                    >
                      <FaDownload />
                    </button>
                    <div className="py-4 bg-blackish mt-5 min-h-[300px] flex items-center justify-center overflow-x-auto">
                      <CustomBarChart
                        data={selectedChurchRows}
                        customHeight={280}
                        customWidth={560}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <ChurchModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Churches;
